import { axiosInstance } from '../../utils';
import { IDraft } from '../../@types';

export const fetchUserDrafts = async (): Promise<IDraft[]> => {
  const res = await axiosInstance.get('/api/videos/draft-videos');
  return res.data;
};
